import { fromJS } from 'immutable';

import {
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
  RESET_TRAVEL_DELAY,
  RESET_CANCELLATION_AMENDMENT,
  RESET_COMPENSATION,
  RESET_ADDITIONAL,
} from './constants';

// The initial state of the App
const initialState = fromJS({
  form: {
    claimForCancellationAmendmentOrDelay: 'false',
    claimForTripCancellationExpenses: 'false',
    claimForTripDisruptionOrAdditionalExpenses: 'false',
    claimForTripResumptionExpenses: 'false',
    claimForAlternativeTransportExpenses: 'false',
    claimForATravelDelay: 'false',
    dateCancellationOrAmendmentMade: '',
    reasonForCancellationOrAmendment: {
      medical: null,
      travel: null,
      weather: null,
      redundancy: null,
      other: null,
      otherDescription: '',
    },
    cancellationExpenses: [],
    additionalExpenses: [],
    delayedTravelReason: '',
    departDate: '',
    departTime: null,
    departedDate: '',
    departedTime: null,
    receivedCompensation: 'false',
    delayedTravelExpenses: [],
    amountOfCompensation: '',
    amountOfCompensationCurrency: '',
    dateCompensationWasReceived: '',
    compensationDescription: '',
    areThereAnyAdditionalExpensesToBeClaimed: 'false',
    enableTime: null,
  },
  errors: [],
});

const emptyTravelDelayExpense = {
  form: {
    claimForATravelDelay: 'false',
    delayedTravelReason: '',
    departDate: '',
    departTime: null,
    departedDate: '',
    departedTime: null,
    receivedCompensation: 'false',
    delayedTravelExpenses: [],
    amountOfCompensation: '',
    amountOfCompensationCurrency: '',
    dateCompensationWasReceived: '',
    compensationDescription: '',
  },
};

const emptyCancellationAmendmentExpense = {
  form: {
    claimForCancellationAmendmentOrDelay: 'false',
    claimForTripCancellationExpenses: 'false',
    claimForTripDisruptionOrAdditionalExpenses: 'false',
    claimForTripResumptionExpenses: 'false',
    claimForAlternativeTransportExpenses: 'false',
    dateCancellationOrAmendmentMade: '',
    reasonForCancellationOrAmendment: {
      medical: null,
      travel: null,
      weather: null,
      redundancy: null,
      other: null,
      otherDescription: '',
    },
    cancellationExpenses: [],
    additionalExpenses: [],
    areThereAnyAdditionalExpensesToBeClaimed: 'false',
  },
};

const emptyCompensationExpense = {
  form: {
    receivedCompensation: 'false',
    amountOfCompensation: '',
    amountOfCompensationCurrency: '',
    dateCompensationWasReceived: '',
    compensationDescription: '',
  },
};

function stepCancellationAdditionalReducer(state = initialState, action) {
  const properties = action.propertyName ? action.propertyName.split('.') : '';
  switch (action.type) {
    case VALUE_CHANGED: {
      return state.setIn(properties, action.value);
    }
    case LOAD:
      return action.payload ? fromJS({ form: action.payload, errors: [] }) : initialState;
    case NEXT:
      return state.merge({ errors: action.errors });
    case RESET:
      return initialState;
    case RESET_TRAVEL_DELAY:
      return state.setIn(['form', 'delayedTravelExpenses'], [])
        .mergeDeep(emptyTravelDelayExpense);
    case RESET_CANCELLATION_AMENDMENT:
      return state.setIn(['form', 'cancellationExpenses'], [])
        .setIn(['form', 'additionalExpenses'], [])
        .mergeDeep(emptyCancellationAmendmentExpense);
    case RESET_COMPENSATION:
      return state.mergeDeep(emptyCompensationExpense);
    case RESET_ADDITIONAL:
      return state.setIn(['form', 'additionalExpenses'], fromJS([]));
    default:
      return state;
  }
}

export default stepCancellationAdditionalReducer;



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepCancellationAdditional/reducer.js